import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    representative,
    creator,
    method,
    date,
    sendTo,
    chiefAccountant,
    address,
    unit,
    year,
  },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [address.name]: "",
  [conpanyName.name]: "",
  [representative.name]: "",
  [creator.name]: "",
  [sendTo.name]: "",
  [chiefAccountant.name]: "",
  [unit.name]: "",
  [year.name]: "",
};

export default initialValues;
